import React from "react";
import { useArtistDisplayName } from "@/api/hooks/useArtistDisplayName";
import { SparkleMaskedName } from "@/components/ui/SparkleMaskedName";

interface MaskProfessionalNameInTextProps {
  value: string | number | null | undefined;
}

const escapeRegExp = (value: string) => value.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

const MaskProfessionalNameInText: React.FC<MaskProfessionalNameInTextProps> = ({ value }) => {
  const displayName = useArtistDisplayName();
  const normalizedDisplayName = displayName.trim();
  const rawValue = String(value ?? "");

  if (!normalizedDisplayName || !rawValue) return <>{rawValue}</>;

  const pattern = new RegExp(`(${escapeRegExp(normalizedDisplayName)})`, "gi");
  const parts = rawValue.split(pattern);

  if (parts.length <= 1) return <>{rawValue}</>;

  return (
    <>
      {parts.map((part, index) =>
        part.toLowerCase() === normalizedDisplayName.toLowerCase() ? (
          <SparkleMaskedName key={`name-${index}`} name={displayName} />
        ) : (
          <React.Fragment key={`text-${index}`}>{part}</React.Fragment>
        )
      )}
    </>
  );
};

export default MaskProfessionalNameInText;
